export default __webpack_public_path__ + "static/media/KiaBongo.1b846bcd.png";